// extracted by mini-css-extract-plugin
export default {"wrapper":"ReviewerCard_wrapper__eRIqd","reviewerSelect":"ReviewerCard_reviewerSelect__2fqav","queueBox":"ReviewerCard_queueBox__zV6xF"};